import React from "react";
import Highlighter from './Highlight'
import { Avatar, Heading, Text } from "base-ui" 
import { PageWrapper } from "./PageWrapper"
import { Avatar as AvatarExample } from '../examples/Avatar'


const Avatars = () => {
    return (
        <PageWrapper title="Avatar">
            <Text size="md">
            The Avatar component is used to represent a user, and displays the profile picture, or falls back to initials if no image is present or if the image image src is broken.
            </Text>
            <div className="space-x-8 py-4">
                <Avatar name="Avatar Name" src="https://picsum.photos/200"/>
                <Avatar name="Avatar Name" size="md" src="https://picsum.photos/200"/>
                <Avatar name="Avatar Name" size="lg" src="" type="Beyond"/>
            </div>
            <Heading size="h3">Usage</Heading>
            <Highlighter code={AvatarExample} language='jsx' />
            
        </PageWrapper>
    )
}

export default Avatars